import styled from 'styled-components';

export const SrpcardLayoutDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  width:100%;
  background-color:${props.theme.colors.white.base};
  margin-bottom:${props.theme.spacing.base};
  border-radius:${props.theme.misc.borderRadius.custom(4)};
  padding-top:${props.theme.spacing.custom(30)};
  padding-bottom:${props.theme.spacing.custom(30)};
  padding-right:${props.theme.spacing.custom(20)};
  padding-left:${props.theme.spacing.custom(20)};
  

`,
);

export const CardContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const cardInnerConetentlayoutDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:35%;

`,
);

export const cardInnerConetentSecondlayoutDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:30%;

`,
);

export const cardInnerConetentThirdlayoutDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:35%;

`,
);

export const RtcBusWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;

`,
);

export const BusTimingWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding-top:${props.theme.spacing.base};
  align-items: center;

`,
);

export const BusPriceDetailsDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding-top:${props.theme.spacing.base};
  justify-content: flex-end;
`,
);

export const BusImageWrapperDiv = styled.div(
  props => `

  display:flex;
  background-color:#d8d8d8;
  height:7.3em;
  width:7.3em;

`,
);

export const BustxtDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding-left:${props.theme.spacing.large};
  padding-top:${props.theme.spacing.base};
  width: 70%;

`,
);

export const BusBoldtxtPara = styled.p(
  props => `

  padding-bottom:${props.theme.spacing.base};
  font-weight: bold;
  font-size:${props.theme.font.custom(20)};
  font-family:${props.theme.font.fontFamily};


`,
);

export const BusNormaltxtPara = styled.p(
  props => `
  color:#777777;
  font-size:${props.theme.font.base};
  line-height:1.6em;
`,
);

export const BusPriceDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding-right:${props.theme.spacing.xxlarge};

`,
);

export const BusDetailsDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;

`,
);

export const PriceSeparationDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding-bottom:${props.theme.spacing.base};

`,
);

export const RupeeSpan = styled.span(
  props => `

  font-size:${props.theme.font.custom(20)};
  padding-right:${props.theme.spacing.small};
`,
);

export const RupeetxtSpan = styled.span(
  props => `

  font-size:${props.theme.font.custom(20)};
  font-family:${props.theme.font.fontFamily};
  font-weight:bold;
`,
);

export const BusTimingWrapNewDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-end;
`,
);

export const PayBtnWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:100%;
  justify-content: space-between;
  padding-left:${props.theme.spacing.base};
  padding-right:${props.theme.spacing.base};
  padding-top:${props.theme.spacing.custom(3)};
  padding-bottom:${props.theme.spacing.custom(3)};

`,
);

export const PayTxtSpan = styled.span(
  props => `
    font-family:${props.theme.font.fontFamily};
    font-size:${props.theme.font.custom(14)};
    font-weight:bold;
`,
);

export const BusBtnDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  padding-top:${props.theme.spacing.base};
`,
);

export const DiscountTag = styled.div`
     background: #D1E5FF;
     padding: 4px 5px;
     border-radius: 2px;
     font-size: 11px;
     color: #141823;
     & .bold{
          font-weight: 700;
     }
`;

export const DiscountPersuation = styled.div`
     background: #D1E5FF;
     border-radius: 4px;
     padding: 12px 18px;
     display: flex;
     align-items: center;
     margin-bottom: 10px
     & .femaleIcon{
          width: 36px;
          height: 36px;
          margin-right: 14px;
     }
     & span{
          font-size: 18px;
          color: #141823;
          line-height: 22px;
          & .bold{
               font-weight: 700
          }
     }

`